import { onCleanup, onMount, reactive } from 'cdui-js';

import { bindOverlayHistory, type OverlayHistoryHandle } from '../../../../lib/overlay-history';
import { getModalContentWidth } from '../../../../lib/modal-layout';
import { API } from './index';

interface Props {
  title?: any;
  content?: any;
  cancelText?: any;
  confirmText?: any;
  onCancel?: () => void;
  onConfirm?: () => void;
  disableClickMask?: boolean;
  fullWidth?: boolean;
  close: any;
  api: API;
}

export const Modal = (props: Props) => {
  const state = reactive({
    isShow: false,
  });

  let history: OverlayHistoryHandle | null = null;

  const finishClose = () => {
    state.isShow = false;
    setTimeout(() => {
      props.close();
    }, 300);
  };

  const handleClose = () => {
    history?.release();
    history = null;
    finishClose();
  };

  onMount(() => {
    history = bindOverlayHistory(() => {
      // 系统后退：等同选否
      props.onCancel?.();
      history = null;
      finishClose();
    });
    setTimeout(() => {
      state.isShow = true;
    }, 0);
  });

  onCleanup(() => {
    history?.release();
    history = null;
  });

  props.api.handleClose = handleClose;

  const renderNode = (node?: any) => {
    if (node == null || node === '') return null;
    return typeof node === 'function' ? node() : node;
  };

  const hasCancelText = () => props.cancelText != null && props.cancelText !== '';
  const hasConfirmText = () => props.confirmText != null && props.confirmText !== '';
  const isDualActions = () => hasCancelText() && hasConfirmText();

  const handleCancel = () => {
    props.onCancel?.();
    handleClose();
  };

  const handleConfirm = () => {
    props.onConfirm?.();
    handleClose();
  };

  const renderActions = () => {
    if (!hasCancelText() && !hasConfirmText()) return null;

    const dualClass = isDualActions() ? ' modal-panel-btn-dual' : '';

    return (
      <div class="modal-panel-actions">
        {hasCancelText() ? (
          <button
            type="button"
            class={`modal-panel-btn modal-panel-btn-cancel btn-rounded${dualClass}`}
            onclick={handleCancel}
          >
            {renderNode(props.cancelText)}
          </button>
        ) : null}
        {hasConfirmText() ? (
          <button
            type="button"
            class={`modal-panel-btn primary-btn btn-rounded${dualClass}`}
            onclick={handleConfirm}
          >
            {renderNode(props.confirmText)}
          </button>
        ) : null}
      </div>
    );
  };

  const panel = () => {
    const body = props.content?.();
    if (props.title == null || props.title === '') {
      return body;
    }

    return (
      <div class="modal-panel bg-c border round-XL width-100">
        <div class="modal-panel-title font-s-L font-bold color-D text-align-center">
          {renderNode(props.title)}
        </div>
        <div class="modal-panel-body font-s-S text-align-center">{body}</div>
        {renderActions()}
      </div>
    );
  };

  return (
    <div
      class={`modal ${state.isShow ? 'modal-show' : 'modal-hide'}`}
      onclick={() => {
        if (props.disableClickMask) return;
        // 点遮罩等同选否
        props.onCancel?.();
        handleClose();
      }}
    >
      <div
        class="modal-content"
        style={{ width: props.fullWidth ? '100%' : getModalContentWidth() }}
        onclick={(e) => {
          e.stopPropagation();
        }}
      >
        {panel()}
      </div>
    </div>
  );
};
